import Actions from '@/Components/Storemanager/Column/Actions';
import Category from '@/Components/Storemanager/Column/Category';
import Field from '@/Components/Storemanager/Column/Field';
import Title from '@/Components/Storemanager/Column/Title';
import FieldCategory from '@/Models/FieldCategory';

export default {
    functional: true,
    props: {
        rows: {
            type: Array,
            required: true,
        },
        hasActions: {
            type: Boolean,
            required: true,
        },
    },

    render(createElement, context) {
        let elements = [];

        // Title
        elements.push(createElement('div', {style: {'width': '0.3px'}}));

        // Actions
        if (context.props.hasActions) {
            elements.push(createElement('div', {style: {'width': '0.3px'}}));
        }

        // Field/Category Rows
        context.props.rows.forEach((row) => {
            if (row instanceof FieldCategory) {
                // Category Row
                elements.push(createElement('div', {style: {'width': '0.3px'}}));

                row.filteredFields.forEach(() => {
                    elements.push(createElement('div', {
                        class: {'hidden': !row.isOpen},
                        style: {'width': '0.3px'},
                    }));
                });
            } else if (!row.is_admin_only || auth.user.isAdmin) {
                // Field Row
                elements.push(createElement('div', {style: {'width': '0.3px'}}));
            }
        });

        return elements;
    },
};
